import React, {useState} from 'react'
import joinClassNames from '../../../helpers/joinClassNames'
import './MenuDropdown.scss'

const MenuDropdown = ({title, children, isFullWidth = true, isRight}) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const [isExpandedDesktop, setIsExpandedDesktop] = useState(false)
    const styles = isFullWidth ? {position: 'static'} : {}

    const toggleShow = () => {
        setIsExpanded((prevIsExpanded) => !prevIsExpanded)
    }

    return (
        <div
            role="button"
            tabIndex={0}
            className="navbar-item has-dropdown"
            style={styles}
            onClick={toggleShow}
            onKeyDown={() => {
                toggleShow()
                setIsExpandedDesktop((prevIsExpanded) => !prevIsExpanded)
            }}
            onMouseOver={() => setIsExpandedDesktop(true)}
            onFocus={() => setIsExpandedDesktop(true)}
            onMouseLeave={() => setIsExpandedDesktop(false)}
        >
            <div className={joinClassNames('navbar-link', isExpanded ? 'is-expanded' : null)}>{title}</div>
            <div
                className={joinClassNames(
                    'navbar-dropdown',
                    isExpanded ? null : 'is-hidden-touch',
                    isRight && 'is-right'
                )}
                style={{display: isExpandedDesktop ? 'block' : 'none'}}
            >
                {children}
            </div>
        </div>
    )
}

export default MenuDropdown
